import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

export const Check = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-base", className)}
  >
    <path
      d="M6.74991 10.5151L13.6106 3.25L14.6667 4.36746L6.74991 12.75L2 7.72063L3.05537 6.60317L6.74991 10.5151Z"
      fill="currentColor"
    />
  </svg>
);
